export const gtmPageView = (path: string) => {

  const eventName = getEventNameFromPath(path);

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: eventName,
      page_path: path,
      page_location: window.location.href,
      page_title: document.title,
      analytics_storage: "granted"
    });
  };
  
const getEventNameFromPath = (path: string) => {
  const match = ROUTE_EVENT_MAP.find(r => r.pattern.test(path));
  return match?.event ?? "page_view"; // fallback
}

const ROUTE_EVENT_MAP: Array<{ pattern: RegExp; event: string }> = [
  { pattern: /^\/home$/, event: "home" },
  { pattern: /^\/quick-order$/, event: "quick_order" },
  { pattern: /^\/label-catalog$/, event: "label_catalog" },
  { pattern: /^\/draft-order$/, event: "draft_order" },
  { pattern: /^\/order-history$/, event: "order_history" },
  { pattern: /^\/contact-us$/, event: "contact_us" },
];
